import React, { Fragment } from 'react';

import usePreCompRegistrationLocationFacilitiesAdd from './UsePreCompRegistrationLocationFacilitiesAdd';

import FacilityDupCheckContent from '@usas/ui-web/components/searches/searchFacility/addFacility/components/FacilityDupCheckContent';
import FacilityForm from '@usas/ui-web/components/searches/searchFacility/addFacility/components/FacilityForm';
import AddressValidation from '@usas/ui-web/components/addressValidation/AddressValidation';

import Headings from '@usas/ui-web/components/headings/Headings';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Constants from '@usas/ui-web/utils/Constants';

//TODO could not use common component because no orgUnitId or context exists
const PreCompRegistrationLocationFacilitiesAdd = () => {
  const {
    formState,
    errorState,
    dupsState,
    clubAffiliationTypeState,
    facilityState,
    onFormValueChanged,
    onCancelClicked,
    onAddDupFacilityClicked,
    onCancelDupFacilityClicked,
    onValueTextPairChanged,
    handleSubmitProxy,
    setFormData,
    validateState
  } = usePreCompRegistrationLocationFacilitiesAdd();

  return (
    <Fragment>
      <form onSubmit={handleSubmitProxy} noValidate>
        <div className="row">
          <div className="col-xs-12">
            <Headings.H3>Add Facility</Headings.H3>
          </div >
        </div >
        <FacilityForm
          formState={formState}
          errorState={errorState}
          onFormValueChanged={onFormValueChanged}
          onValueTextPairChanged={onValueTextPairChanged} />
        {formState.isInternational === false
          ? <AddressValidation formState={formState} setFormData={setFormData} />
          : <Fragment />}
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="submit">Save</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onCancelClicked}>Back</SecondaryButton>
          </div>
        </div>
      </form >
      {validateState.isValidating === true && (
        <PopUpModal
          displayPopUp={true}
          maxWidth={250}
          title="Validating..."
          widthPct={50} />
      )}
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={clubAffiliationTypeState.isArrayLoading || dupsState.isArrayLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={facilityState.isSaving} />
      <PopUpModal
        title="Facility Duplicate Check"
        displayPopUp={dupsState.arrayData.length > 0}>
        <FacilityDupCheckContent
          formState={formState}
          dupsState={dupsState}
          onAddDupFacilityClicked={onAddDupFacilityClicked}
          onCancelDupFacilityClicked={onCancelDupFacilityClicked} />
      </PopUpModal>
    </Fragment >
  );
};

export default PreCompRegistrationLocationFacilitiesAdd;